import styled from 'styled-components'

export const LoadingWrapper = styled.div`
	padding: 8px;
`
